// Added to keep consistent with default angular project
import {environment as builtEnvironment} from './dist/environment';
import {Environment} from './models/environment.model';

export const environment: Environment = builtEnvironment;

